module.exports = __webpack_public_path__ + "static/img/bridges01.735b2c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/bridges01.jpg
// module id = W5LS
// module chunks = 0